// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_Password from "../Ouroboros.Models.Brands.Password/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PasswordResetCompleteAction = function (x) {
    return x;
};
var FormMissing = /* #__PURE__ */ (function () {
    function FormMissing() {

    };
    FormMissing.value = new FormMissing();
    return FormMissing;
})();
var FormMismatch = /* #__PURE__ */ (function () {
    function FormMismatch() {

    };
    FormMismatch.value = new FormMismatch();
    return FormMismatch;
})();
var FormValid = /* #__PURE__ */ (function () {
    function FormValid(value0) {
        this.value0 = value0;
    };
    FormValid.create = function (value0) {
        return new FormValid(value0);
    };
    return FormValid;
})();
var tsBridgePasswordResetComp = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("PasswordResetCompleteAction")("__brandPasswordResetCompleteAction"));
        });
    }
};
var toMaybe = /* #__PURE__ */ (function () {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Data_Maybe.Nothing.value;
    })(Data_Maybe.Just.create);
})();
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.PasswordResetComplete (line 93, column 7 - line 95, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.passwordResetErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runPasswordResetCompleteAction = function (v) {
    return v;
};
var runLoadingAction = function (v) {
    return v;
};
var readState = function (v) {
    return v;
};
var readForm = function (env) {
    var v = toMaybe(readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.password)));
    if (v instanceof Data_Maybe.Nothing) {
        return FormMissing.value;
    };
    if (v instanceof Data_Maybe.Just) {
        var v1 = toMaybe(readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(env.confirmPassword)));
        if (v1 instanceof Data_Maybe.Nothing) {
            return FormMissing.value;
        };
        if (v1 instanceof Data_Maybe.Just) {
            var $33 = v.value0 === v1.value0;
            if ($33) {
                return new FormValid(v.value0);
            };
            return FormMismatch.value;
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.PasswordResetComplete (line 112, column 7 - line 118, column 25): " + [ v1.constructor.name ]);
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.PasswordResetComplete (line 109, column 3 - line 118, column 25): " + [ v.constructor.name ]);
};
var mkPasswordResetCompleteAction = PasswordResetCompleteAction;
var missingTokenError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Missing reset token. Please request a new link."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var missingPasswordError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Please enter and confirm your new password."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var mismatchedPasswordError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Passwords do not match."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var handleSuccess = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(env.onSuccess);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess)));
};
var handlePasswordResetError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var submitAndHandle = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePasswordResetError(env))(function (v) {
            return handleSuccess(env);
        })(env.completePasswordReset(request));
    };
};
var submitPasswordReset = function (env) {
    var v = toMaybe(env.token);
    if (v instanceof Data_Maybe.Nothing) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingTokenError)));
    };
    if (v instanceof Data_Maybe.Just) {
        var v1 = readForm(env);
        if (v1 instanceof FormMissing) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingPasswordError)));
        };
        if (v1 instanceof FormMismatch) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(mismatchedPasswordError)));
        };
        if (v1 instanceof FormValid) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v2) {
                return submitAndHandle(env)({
                    token: v.value0,
                    password: Ouroboros_Models_Brands_Password.makePassword(v1.value0)
                });
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.PasswordResetComplete (line 62, column 7 - line 70, column 68): " + [ v1.constructor.name ]);
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.PasswordResetComplete (line 58, column 3 - line 70, column 68): " + [ v.constructor.name ]);
};
var mkPasswordResetCompleteController = function (env) {
    return {
        submit: mkPasswordResetCompleteAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitPasswordReset(env)))
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/password_reset_complete_controller.md";
export {
    PasswordResetCompleteAction,
    mkPasswordResetCompleteController,
    runPasswordResetCompleteAction,
    documentationPath,
    tsBridgePasswordResetComp
};
//# sourceMappingURL=index.js.map
